import React from "react";
import { Warning } from "@material-ui/icons";

export default function ModalConfirm({
  title,
  message,
  onConfirm,
  onClose,
  icon: Icon = Warning,
  iconColor = "var(--fg-error-default)",
  backgroundColor = "var(--bg-error-subtler)",
  oneButtonMessage,
  confirmButtonMessage = "Confirmar",
  cancelButtonMessage = "Cancelar",
  isLoading = false,
  children,
}) {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <div
      className="jds-modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "var(--state-overlay)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999
      }}
      
    >
      <div
        className="jds-modal-box"
        style={{
          background: "var(--bg-floating)",
          borderRadius: "8px",
          padding: "32px",
          minWidth: "320px",
          boxShadow: "var(--shadow-xl)",
          textAlign: "center"
        }}
      >
        <Icon
          style={{
            color: iconColor,
            fontSize: 64,
            marginBottom: 16,
            background: backgroundColor,
            borderRadius: "8px"
          }}
        />
        <h2>{title}</h2>
        <p>{message}</p>
        {children}
        <div
          style={{
            marginTop: 24,
            display: "flex",
            justifyContent: "center",
            gap: 16
          }}
        >
          {oneButtonMessage ? (
            <button
              className="btn btn-primary w-100"
              onClick={handleCloseModal}
            >
              {oneButtonMessage}
            </button>
          ) : (
            <>
              <button
                className="btn btn-outline-primary w-100"
                onClick={handleCloseModal}
                disabled={isLoading}
              >
                {cancelButtonMessage}
              </button>
              <button
                className="btn btn-primary w-100"
                onClick={handleConfirm}
                disabled={isLoading}
              >
                {isLoading && <span className="jds-btn__spinner mr-2" />}
                {confirmButtonMessage}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
